import { combineReducers } from 'redux';
import questions from './questions';
import settings from './settings';
import quizes from './quizes';
import favorites from './favorites';
import battle from './battle';
export default combineReducers({
    questions,
    settings,
    quizes,
    favorites,
    battle
});